import { Injectable, OnDestroy } from '@angular/core';
import { fromEvent, Subscription, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class VisibilityService implements OnDestroy {
  // Watch for events on the window (or any other element).
  visibilityChange = fromEvent(document, 'visibilitychange');
  // Hold a reference to the subscribption.
  visibilitySubscription?: Subscription;

  constructor() {
    // Subscribe to the property or use the async pipe.
    // Remember to unsubscribe when you are done if you don't use the async pipe.
    this.visibilitySubscription = this.visibilityChange.subscribe();
  }

  ngOnDestroy() {
    // Destroy the subscription.
    this.visibilitySubscription?.unsubscribe();
  }
}
